// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"608":"cb6c11c7","808":"d7052325","943":"bbc3600c"}[chunkId] + ".css";
};